export const percentages = [
  { value: "25%", text: "25 %" },
  { value: "50%", text: "50 %" },
  { value: "75%", text: "75 %" },
];
